import { useEffect, useState, useContext } from "react"
import NavIcon from "./NavIcon"
import { useLocation } from "react-router-dom"
import { AppParamsContext } from "contexts/AppParamsContext"
import { isDesktop } from "react-device-detect"

export default function BottomBarV2() {
  const { appParams } = useContext(AppParamsContext)
  const location = useLocation()

  const { size, layout, text } = appParams?.navigation?.bottomBarSettings || {}

  const [navElements, setNavElements] = useState([])
  const [classes, setClasses] = useState("")

  useEffect(() => {
    if (appParams?.navigation?.bottomBarElementsV2) {
      setNavElements(
        Object.values(appParams?.navigation?.bottomBarElementsV2 || {})
          ?.filter((elem) => elem != null)
          ?.sort((a, b) => a?.idx - b?.idx)
      )
      let classStr =
        "flex justify-around gap-2 overflow-auto bg-[var(--bottom-bar-bg-color)] shrink-0 p-2 rounded-[var(--general-border-radius)]"
      if (isDesktop) {
        classStr += " absolute left-3 top-[130px] flex-col"
      } else {
        if (layout === "floating") {
          classStr +=
            " absolute bottom-6 z-30 mx-4 w-[calc(100%-2rem)] rounded-[var(--general-border-radius)] border-1 border-solid border-[var(--bottom-bar-border-color)]"
        } else {
          classStr +=
            " border-t-1 border-solid border-[var(--bottom-bar-border-color)]"
        }
      }

      setClasses(classStr)
    }
    //eslint-disable-next-line
  }, [appParams])

  if (location.pathname.startsWith("/menu")) return null

  return (
    <div className={classes}>
      {navElements.map((navElement) => (
        <NavIcon
          key={navElement.uuid}
          data={navElement}
          size={size}
          text={text}
        />
      ))}
    </div>
  )
}
